var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.0136719C14.0428 0.0136719 12.1679 0.365734 10.4347 1.00886L9.73901 16.0137L10.4346 31.0185C12.1679 31.6617 14.0428 32.0137 15.9999 32.0137C17.957 32.0137 19.8318 31.6617 21.5651 31.0185L22.2607 16.0137L21.5651 1.00886C19.8318 0.365734 17.957 0.0136719 15.9999 0.0136719V0.0136719Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0136C32 9.13413 27.658 3.26945 21.5652 1.00876V31.0184C27.658 28.7577 32 22.893 32 16.0136V16.0136Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 31.0184V1.00876C4.342 3.26945 0 9.13413 0 16.0136C0 22.893 4.342 28.7577 10.4348 31.0184Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0136719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChad);
export default __webpack_public_path__ + "static/media/chad.fa4e8a6e.svg";
export { ForwardRef as ReactComponent };